import { CLASSES as C } from "../Types.js";
import { Attribute as p } from "../Attribute.js";
import { AttributeDefinitions as O } from "../AttributeDefinitions.js";
import { DockLocation as m } from "../DockLocation.js";
import { DropInfo as z } from "../DropInfo.js";
import { Orientation as T } from "../Orientation.js";
import { Rect as E } from "../Rect.js";
import { BorderNode as D } from "./BorderNode.js";
import { Node as x } from "./Node.js";
import { SplitterNode as b } from "./SplitterNode.js";
import { TabSetNode as u } from "./TabSetNode.js";
class f extends x {
  static TYPE = "row";
  /** @internal */
  static _fromJson(t, e) {
    const i = new f(e, t);
    if (t.children != null)
      for (const s of t.children)
        if (s.type === u.TYPE) {
          const r = u._fromJson(s, e);
          i._addChild(r);
        } else {
          const r = f._fromJson(s, e);
          i._addChild(r);
        }
    return i;
  }
  /** @internal */
  static _attributeDefinitions = f._createAttributeDefinitions();
  /** @internal */
  static _createAttributeDefinitions() {
    const t = new O();
    return t.add("type", f.TYPE, !0).setType(p.STRING).setFixed(), t.add("id", void 0).setType(p.STRING), t.add("weight", 100).setType(p.NUMBER), t.add("width", void 0).setType(p.NUMBER), t.add("height", void 0).setType(p.NUMBER), t;
  }
  /** @internal */
  _drawChildren;
  /** @internal */
  _minHeight;
  /** @internal */
  _minWidth;
  /** @internal */
  constructor(t, e) {
    super(t), this._dirty = !0, this._drawChildren = [], this._minHeight = 0, this._minWidth = 0, f._attributeDefinitions.fromJson(e, this._attributes), t._addNode(this);
  }
  getWeight() {
    return this._attributes.weight;
  }
  getWidth() {
    return this._getAttr("width");
  }
  getHeight() {
    return this._getAttr("height");
  }
  /** @internal */
  _setWeight(t) {
    this._attributes.weight = t;
  }
  /** @internal */
  _layout(t, e) {
    super._layout(t, e);
    const i = this._rect._getSize(this.getOrientation());
    let s = 0, r = 0, d = 0, c = 0;
    const h = this._getDrawChildren();
    for (const o of h) {
      const a = o._getPrefSize(this.getOrientation());
      o._isFixed() ? a !== void 0 && (r += a) : a === void 0 ? s += o.getWeight() : (d += a, c += o.getWeight());
    }
    let n = !1, _ = i - r - d;
    _ < 0 && (_ = i - r, n = !0, s += c);
    let l = 0, g = 0;
    for (const o of h) {
      const a = o._getPrefSize(this.getOrientation());
      if (o._isFixed())
        a !== void 0 && o._setTempSize(a);
      else if (a == null || n) {
        if (s === 0)
          o._setTempSize(0);
        else {
          const S = o.getMinSize(this.getOrientation()), w = Math.floor(_ * (o.getWeight() / s));
          o._setTempSize(Math.max(S, w));
        }
        g += o._getTempSize();
      } else
        o._setTempSize(a);
      l += o._getTempSize();
    }
    if (g > 0) {
      for (; l < i; )
        for (const o of h)
          if (!(o instanceof b)) {
            const a = o._getPrefSize(this.getOrientation());
            !o._isFixed() && (a === void 0 || n) && l < i && (o._setTempSize(o._getTempSize() + 1), l++);
          }
      for (; l > i; ) {
        let o = !1;
        for (const a of h)
          if (!(a instanceof b)) {
            const S = a.getMinSize(this.getOrientation());
            a._getTempSize() > S && l > i && (a._setTempSize(a._getTempSize() - 1), l--, o = !0);
          }
        if (!o)
          break;
      }
      for (; l > i; ) {
        let o = !1;
        for (const a of h)
          a instanceof b || a._getTempSize() > 0 && l > i && (a._setTempSize(a._getTempSize() - 1), l--, o = !0);
        if (!o)
          break;
      }
    }
    let W = 0;
    for (const o of h)
      this.getOrientation() === T.HORZ ? o._layout(new E(this._rect.x + W, this._rect.y, o._getTempSize(), this._rect.height), e) : o._layout(new E(this._rect.x, this._rect.y + W, this._rect.width, o._getTempSize()), e), W += o._getTempSize();
    return !0;
  }
  /** @internal */
  _getSplitterBounds(t, e = !1) {
    const i = [0, 0], s = this._getDrawChildren(), r = s.indexOf(t), d = s[r - 1], c = s[r + 1];
    if (this.getOrientation() === T.HORZ) {
      const h = e ? d.getMinWidth() : 0, n = e ? c.getMinWidth() : 0;
      i[0] = d.getRect().x + h, i[1] = c.getRect().getRight() - t.getWidth() - n;
    } else {
      const h = e ? d.getMinHeight() : 0, n = e ? c.getMinHeight() : 0;
      i[0] = d.getRect().y + h, i[1] = c.getRect().getBottom() - t.getHeight() - n;
    }
    return i;
  }
  /** @internal */
  _calculateSplit(t, e) {
    let i;
    const s = this._getDrawChildren(), r = s.indexOf(t), d = this._getSplitterBounds(t), c = s[r - 1].getWeight() + s[r + 1].getWeight(), h = Math.max(0, e - d[0]), n = Math.max(0, d[1] - e);
    if (h + n > 0) {
      const _ = h * c / (h + n), l = n * c / (h + n);
      i = {
        node1Id: s[r - 1].getId(),
        weight1: _,
        pixelWidth1: h,
        node2Id: s[r + 1].getId(),
        weight2: l,
        pixelWidth2: n
      };
    }
    return i;
  }
  /** @internal */
  _getDrawChildren() {
    if (this._dirty) {
      this._drawChildren = [];
      for (let t = 0; t < this._children.length; t++) {
        const e = this._children[t];
        if (t !== 0) {
          const i = new b(this._model);
          i._setParent(this), this._drawChildren.push(i);
        }
        this._drawChildren.push(e);
      }
      this._dirty = !1;
    }
    return this._drawChildren;
  }
  /** @internal */
  getMinSize(t) {
    return t === T.HORZ ? this.getMinWidth() : this.getMinHeight();
  }
  /** @internal */
  getMinWidth() {
    return this._minWidth;
  }
  /** @internal */
  getMinHeight() {
    return this._minHeight;
  }
  /** @internal */
  calcMinSize() {
    this._minHeight = 0, this._minWidth = 0;
    let t = !0;
    for (const e of this._children) {
      const i = e;
      i instanceof f && i.calcMinSize(), this.getOrientation() === T.VERT ? (this._minHeight += i.getMinHeight(), t || (this._minHeight += this._model.getSplitterSize()), this._minWidth = Math.max(this._minWidth, i.getMinWidth())) : (this._minWidth += i.getMinWidth(), t || (this._minWidth += this._model.getSplitterSize()), this._minHeight = Math.max(this._minHeight, i.getMinHeight())), t = !1;
    }
  }
  /** @internal */
  _tidy() {
    let t = 0;
    for (; t < this._children.length; ) {
      const e = this._children[t];
      if (e instanceof f) {
        e._tidy();
        const i = e.getChildren();
        if (i.length === 0)
          this._removeChild(e);
        else if (i.length === 1) {
          const s = i[0];
          if (this._removeChild(e), s instanceof f) {
            let r = 0;
            const d = s.getChildren();
            for (const c of d)
              r += c.getWeight();
            for (let c = 0; c < d.length; c++) {
              const h = d[c];
              h._setWeight(e.getWeight() * h.getWeight() / r), this._addChild(h, t + c);
            }
          } else
            s._setWeight(e.getWeight()), this._addChild(s, t);
        } else
          t++;
      } else e instanceof u && e.getChildren().length === 0 && e.isEnableDeleteWhenEmpty() ? (this._removeChild(e), e === this._model.getMaximizedTabset() && this._model._setMaximizedTabset(void 0)) : t++;
    }
    if (this === this._model.getRoot() && this._children.length === 0) {
      const e = this._model._getOnCreateTabSet();
      let i = e ? e() : {};
      i = { ...i, selected: -1 };
      const s = new u(this._model, i);
      this._model._setActiveTabset(s), this._addChild(s);
    }
  }
  /** @internal */
  canDrop(t, e, i) {
    const s = i - this._rect.y, r = e - this._rect.x, d = this._rect.width, c = this._rect.height, h = 10, n = 50;
    let _;
    if (this._model.isEnableEdgeDock() && this._parent === void 0) {
      if (e < this._rect.x + h && s > c / 2 - n && s < c / 2 + n) {
        const l = m.LEFT, g = l.getDockRect(this._rect);
        g.width = g.width / 2, _ = new z(this, g, l, -1, C.FLEXLAYOUT__OUTLINE_RECT_EDGE);
      } else if (e > this._rect.getRight() - h && s > c / 2 - n && s < c / 2 + n) {
        const l = m.RIGHT, g = l.getDockRect(this._rect);
        g.width = g.width / 2, g.x += g.width, _ = new z(this, g, l, -1, C.FLEXLAYOUT__OUTLINE_RECT_EDGE);
      } else if (i < this._rect.y + h && r > d / 2 - n && r < d / 2 + n) {
        const l = m.TOP, g = l.getDockRect(this._rect);
        g.height = g.height / 2, _ = new z(this, g, l, -1, C.FLEXLAYOUT__OUTLINE_RECT_EDGE);
      } else if (i > this._rect.getBottom() - h && r > d / 2 - n && r < d / 2 + n) {
        const l = m.BOTTOM, g = l.getDockRect(this._rect);
        g.height = g.height / 2, g.y += g.height, _ = new z(this, g, l, -1, C.FLEXLAYOUT__OUTLINE_RECT_EDGE);
      }
      if (_ !== void 0 && !t._canDockInto(t, _))
        return;
    }
    return _;
  }
  /** @internal */
  drop(t, e, i) {
    const s = e, r = t.getParent();
    r && r._removeChild(t), r !== void 0 && r.getType() === u.TYPE && r._setSelected(0), r !== void 0 && r.getType() === D.TYPE && r._setSelected(-1);
    let d;
    if (t instanceof u)
      d = t;
    else {
      const n = this._model._getOnCreateTabSet();
      d = new u(this._model, n ? n(t) : {}), d._addChild(t);
    }
    let c = this._children.reduce((n, _) => n + _.getWeight(), 0);
    c === 0 && (c = 100), d._setWeight(c / 3);
    const h = !this._model.isRootOrientationVertical();
    if (h && s === m.LEFT || !h && s === m.TOP)
      this._addChild(d, 0);
    else if (h && s === m.RIGHT || !h && s === m.BOTTOM)
      this._addChild(d);
    else if (h && s === m.TOP || !h && s === m.LEFT) {
      const n = new f(this._model, {}), _ = new f(this._model, {});
      _._setWeight(75), d._setWeight(25);
      for (const l of this._children)
        _._addChild(l);
      this._removeAll(), n._addChild(d), n._addChild(_), this._addChild(n);
    } else if (h && s === m.BOTTOM || !h && s === m.RIGHT) {
      const n = new f(this._model, {}), _ = new f(this._model, {});
      _._setWeight(75), d._setWeight(25);
      for (const l of this._children)
        _._addChild(l);
      this._removeAll(), n._addChild(_), n._addChild(d), this._addChild(n);
    }
    this._model._setActiveTabset(d), this._model._tidy();
  }
  toJson() {
    const t = {};
    f._attributeDefinitions.toJson(t, this._attributes), t.children = [];
    for (const e of this._children)
      t.children.push(e.toJson());
    return t;
  }
  isEnableDrop() {
    return !0;
  }
  /** @internal */
  _getPrefSize(t) {
    let e = this.getWidth();
    return t === T.VERT && (e = this.getHeight()), e;
  }
  /** @internal */
  _getAttributeDefinitions() {
    return f._attributeDefinitions;
  }
  /** @internal */
  _updateAttrs(t) {
    f._attributeDefinitions.update(t, this._attributes);
  }
  /** @internal */
  static getAttributeDefinitions() {
    return f._attributeDefinitions;
  }
}
export {
  f as RowNode
};
//# sourceMappingURL=RowNode.js.map
